module.exports = __webpack_public_path__ + "img/talpref.9c85e62a.jpg";